import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Button from '@mui/material/Button';
import { useQuery } from "@tanstack/react-query";
import { useSetRecoilState } from "recoil";
import { getQuestionnaires } from "../../utilities/datalayer";
import { Typography } from "@mui/material";
import _find from "lodash/find";
import { current, currentQuestionnaire } from "./../../utilities/state";


const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 'auto',
    minWidth: '70%',
    bgcolor: 'background.paper',
    border: '1px solid #dedede',
    boxShadow: 12,
    p: 4
}

function ModalQSCSelect(props) {

    const [questionnaire, setQuestionnaire] = useState('');
    const setCurrentQuestionnaire = useSetRecoilState(currentQuestionnaire);
    const setCurrent = useSetRecoilState(current);
    const { data: dataQuestionnaires, error: errorQuestionnaires, isError, isLoading: isLoadingQuestionnaires } = useQuery(['questionnaires'], getQuestionnaires);
    const navigator = useNavigate();

    const handleLoadQuestionnaire = () => {
        let found = _find(dataQuestionnaires, { questionnaireId: questionnaire });
        setCurrentQuestionnaire(found);
        setCurrent({});
        navigator("/qsc");
        props.handleClose();
    }

    const handleClose = () => {
        props.handleClose();
    }

    const handleChange = (event) => { 
       setQuestionnaire(event.target.value);       
    }

    return (
        <>
            <Modal open={props.open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <Box sx={style}>
                    <Typography variant="h6" component="h2" sx={{mb: 4}}>
                        Select a questionnaire:
                    </Typography>
                    <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Questionnaire</InputLabel>
                        <Select labelId="demo-simple-select-label" id="demo-simple-select" value={questionnaire} label="Questionnaire" onChange={handleChange}>
                            {
                                !isLoadingQuestionnaires && dataQuestionnaires &&
                                dataQuestionnaires.map((item, index) => {
                                    return <MenuItem value={item.questionnaireId} key={index}>{item.name}</MenuItem>
                                })
                            }
                        </Select>
                        <Button variant="outlined" disabled={questionnaire < 1} sx={{mt: 6}} onClick={handleLoadQuestionnaire}>BEGIN</Button>
                    </FormControl>
                </Box>
            </Modal>
        </>
    )
}

export default ModalQSCSelect
